import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { theme } from './material-ui/theme';
import RootPage from './components/RootPage';
import Amplify, { I18n } from 'aws-amplify';
import { withAuthenticator } from 'aws-amplify-react';
import { amplifyConfig } from './amplifyConfig';
import { getLogger } from './utils';

getLogger().info('Amplify config', amplifyConfig);
Amplify.configure(amplifyConfig);

I18n.putVocabulariesForLanguage('ja', {
  'Sign in to your account': 'ログイン',
  'Username': 'ユーザー名',
  'Enter your username': 'ユーザー名を入力してください',
  'Password': 'パスワード',
  'Enter your password': 'パスワードを入力してください',
  'Forget your password? ': 'パスワードを忘れた場合　→　',
  'Reset password': 'パスワードをリセットする',
  'Sign In': 'ログイン',
  'Reset your password': 'パスワードをリセットする',
  'Send Code': 'リセットメールを送信',
  'Back to Sign In': 'ログインへ戻る',
  'Sign Out': 'ログアウト',
  'No account? ': ' ',
  'Create account': ' ',
  'Submit': '送信',
  'Resend Code': 'リセットメールを再送信',
  'Code': 'コード',
  'Change Password': 'パスワードを変更してください',
  'New Password': '新しいパスワード',
  'Change': '変更する',
  'Verify': '確認コードを送信',
  'Skip': 'スキップ',
  'Account recovery requires verified contact information': 'アカウント復旧に備えて連絡先を確認してください'
});

I18n.setLanguage('ja');

class App extends React.Component<{}, {}> {
  render() {
    return (
      <div className='App'>
        <MuiThemeProvider theme={theme}>
          <RootPage />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withAuthenticator(App);



// WEBPACK FOOTER //
// ./src/App.tsx